const Skills = () => {
  return (
    <section className="bg-tertiary py-24" id="skills">
      <div className="container mx-auto max-w-5xl">
        <div className="mb-16">
          <p className="text-accent uppercase tracking-widest text-sm mb-4">
            Capacidades técnicas
          </p>

          <h2 className="text-3xl md:text-4xl font-bold">
            Backend orientado a diseño estructural
          </h2>
        </div>

        {/* Diferencial */}
        <div className="mb-20">
          <h3 className="text-xl font-semibold text-white mb-6">
            Diseño de sistemas
          </h3>

          <ul className="space-y-4 text-paragraph leading-relaxed">
            <li>Modelado de dominio y definición de límites claros</li>
            <li>Arquitectura por capas y separación de responsabilidades</li>
            <li>
              Diseño de APIs REST con control de acceso y validación robusta
            </li>
            <li>Gestión segura de credenciales e integraciones externas</li>
            <li>Refactorización orientada a estabilidad y mantenibilidad</li>
          </ul>
        </div>

        {/* Stack principal */}
        <div className="grid md:grid-cols-2 gap-16 text-paragraph mb-20">
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Lenguajes</h3>
            <p>TypeScript · Java</p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-white mb-4">
              Entorno backend
            </h3>
            <p>Node.js · NestJS · Spring Boot</p>
          </div>
        </div>

        {/* Soporte */}
        <div className="grid md:grid-cols-2 gap-16 text-paragraph">
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">
              Bases de datos
            </h3>
            <p>SQL Server · MySQL · SQLite · MongoDB</p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-white mb-4">
              Infraestructura y herramientas
            </h3>
            <p>AWS S3 · AWS Lambda · ECS · Git · GitHub</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
